import React, { useContext, useState } from 'react'
import { BasePopupContext } from '../../../hooks/usePopup';
import { FormattedMessage, useIntl } from 'react-intl';
import useApi from '../../../hooks/useApi';
import { error_alert, success_alert } from '../../../utils';
import { network_tl } from '../../../translations';
import { BiLoaderAlt } from 'react-icons/bi';

const Public = ({ refreshListing, item,deliverableId }) => {
  const [loading, setLoading] = useState(false);
  const intl = useIntl()
  const { Axios } = useApi();

  const { closePopup } = useContext(BasePopupContext)

  const handleSubmit = async () => {
    setLoading(true)
    let payload = {
        status: "public"
    }
    try {
      const result = await Axios.patch(`api/user/change-status/${item.id}`, payload)
      success_alert(result.data.description)
      closePopup()
      refreshListing();
      setLoading(false);
    } catch (e) {
      if (e.response) {
        error_alert(JSON.stringify(e.response.data.description))
      } else {
        error_alert(network_tl(intl))
      }
      setLoading(false);
    }
  }

  return (
    <>
      <div className='text-gray-600 mb-5 '>
        <FormattedMessage id="make_public_desc" defaultMessage={"Are you sure you want to make this influencer public?"} />
      </div>
      <div className='flex justify-end'>
        <button
          onClick={handleSubmit}
          disabled={loading}
          className='btn btn-primary'>
          {
            loading ?
              <BiLoaderAlt className='text-xl mx-auto text-white animate-spin' />
            :
              <FormattedMessage id="yes_proceed" defaultMessage={"Yes, Proceed"} />

          }
        </button>
      </div>

    </>
  )
}

export default Public